import"./text_module.css";let x={base:"base-ZT0G_C",xxs:"xxs-HOloDB",xs:"xs-gX8V3R",sm:"sm-N42BMN",md:"md-n21rmN",lg:"lg-ScIql8",xlg:"xlg-NpFEWZ",xxlg:"xxlg-IS7NiY"};export{x as default};
//# sourceMappingURL=text.module.js.map